<template>
  <div>
    <Modal v-model="show" :title="id ? `编辑类型「${name}」` :'添加新类型'">
      <Alert v-if="dataGetError" type="error">
        数据获取失败
        <a style="float: right" v-on:click="getInfo">刷新</a>
      </Alert>
      <Form :model="type" ref="typeForm" v-else :rules="rules">
        <FormItem label="类型名称" prop="name">
          <Input maxlength="48" show-word-limit v-model="type.name"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="submitting">提交</Button>
        <Button @click="show = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { detailContainerTemplateType, editContainerTemplateType } from '@/api/container/template'

export default {
  name: 'typeEdit',
  data () {
    return {
      submitting: false,
      dataGetting: false,
      dataGetError: false,
      show: false,
      id: null,
      name: '',
      type: {
        name: ''
      },
      rules: {
        name: {required: true, message: '类型名称是必填的', trigger: 'blur'}
      }
    }
  },
  methods: {
    showModal (id = null) {
      this.id = id
      this.type.name = ''
      this.getInfo()
      this.show = true
    },
    getInfo () {
      if (this.id) {
        this.dataGetting = true
        this.dataGetError = false
        detailContainerTemplateType(this.id).then(res => {
          this.type.name = res.data.name
          this.name = res.data.name
          this.dataGetting = false
        }).catch(res => {
          this.dataGetError = true
          this.dataGetting = false
          console.error(res.response)
        })
      }
    },
    submit () {
      this.$refs.typeForm.validate((valid) => {
        if (valid) {
          this.submitting = true
          editContainerTemplateType(this.type, this.id).then(res => {
            this.$emit('callback')
            this.$Notice.success({title: '操作成功'})
            this.show = false
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
            console.error(res.response)
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
